/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// Styled components 💅 is library that allows you create components easily and
// style them, css-in-js style. It's totally optional, but I prefer to use it
// to build things quickly and have them look great every step of the way.
import styled from "styled-components";

// Style components take CSS in a template string. Even Sass functions with work!
// Each element is a property of styled, like h3, p, div, etc...
const InputField = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  margin: ${(props) => (props.topLabel ? "30px 0px 0px 0px" : "0px")};
`;

const InputWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;

  @media (max-width: 600px) {
    flex-direction: column !important;
  }
`;

const Label = styled.div`
  font-size: ${(props) => (props.topLabel ? "1em" : ".8em")};
  position: absolute;
  top: ${(props) => (props.topLabel ? "-20px" : "2px")};
  left: ${(props) => (props.topLabel ? "0px" : "6px")};
  font-weight: ${(props) => (props.topLabel ? "700" : "400")};
  color: ${(props) => (props.topLabel ? "#9b9b9b" : "grey")};
  display: flex;
`;

const StyledInput = styled.input`
  height: 44px;
  background-color: ${(props) => (props.error || props.hasError ? "rgba(255, 217, 218, .5)" : "#FFFFFF")};
  border-style: solid;
  border-width: 1px;
  border-color: rgba(34, 36, 38, 0.15);
  cursor: ${(props) => (props.disabled ? "not-allowed" : null)};

  border-top-left-radius: ${(props) => ((props.topElement && props.leftElement) || (props.singleElement && props.topElement) ? "4px !important" : props.rounded ? "4p !importantx" : "0px !important")};
  border-top-right-radius: ${(props) => ((props.topElement && props.rightElement) || (props.singleElement && props.topElement) ? "4px !important" : props.rounded ? "4px !important" : "0px !important")};
  border-bottom-left-radius: ${(props) => ((props.bottomElement && props.leftElement) || (props.singleElement && props.bottomElement) ? "4px !important" : props.rounded ? "4px !important" : "0px !important")};
  border-bottom-right-radius: ${(props) => ((props.bottomElement && props.rightElement) || (props.singleElement && props.bottomElement) ? "4px !important" : props.rounded ? "4px !important" : "0px !important")};
  border-radius: ${(props) => (props.singleElement ? "4px" : null)};

  border-top-width: ${(props) => (props.topElement || props.bottomElement ? "1px !important" : props.bottomElement ? "0px !important" : null)};
  border-right-width: ${(props) => (props.rightElement || props.singleElement ? "1px !important" : props.topElement || props.leftElement || props.rowElement ? "0px !important" : null)};
  border-left-width: ${(props) => (props.leftElement || props.singleElement ? "1px !important" : null)};
  border-bottom-width: ${(props) => (props.bottomElement || props.singleElement ? "1px !important" : props.topElement || props.leftElement || props.rightElement || props.rowElement ? "0px !important" : null)};

  padding: ${(props) => (props.topLabel ? ".5em" : props.label ? "1em 0em 0em .5em" : ".5em")};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  color: ${(props) => (props.disabled ? "#9b9b9b" : "rgba(0,0,0,.7)")};
  font-size: 1em;

  &:focus {
    background-color: #fafafa;
  }

  &:hover {
    background-color: #fafafa;
  }

  @media (max-width: 600px) {
    border-top-left-radius: ${(props) => (props.topElement ? "4px" : "0px")};
    border-top-right-radius: ${(props) => (props.topElement ? "4px" : "0px")};
    border-bottom-left-radius: ${(props) => (props.bottomElement ? "4px" : "0px")};
    border-bottom-right-radius: ${(props) => (props.bottomElement ? "4px" : "0px")};

    border-width: ${(props) => (props.topElement ? "1px 1px 0px 1px" : props.rowElement ? "1px 1px 0px 1px" : props.bottomElement ? "1px" : null)};
  }
`;

const CloseIcon = styled.i`
  position: absolute;
  right: 6px;
  display: flex;
  align-self: center;
  height: auto !important;
  color: rgba(0, 0, 0, 0.2);
  font-size: 1em !important;
  cursor: pointer;
  transition: 0.2s ease;
  padding: 2px 0px 0px 0px;

  &:hover {
    color: rgba(0, 0, 0, 0.15);
  }
`;

const ErrorMessage = styled.span`
  font-style: italic;
  color: #fe5f55;
`;

export { InputField, Label, StyledInput, InputWrapper, CloseIcon, ErrorMessage };
